import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { CustomerRoute } from './CustomerRoute';
import PortalLogin from './pages/PortalLogin';
import PortalAuthCallback from './pages/PortalAuthCallback';
import PortalHome from './pages/PortalHome';
import PortalEstimateDetail from './pages/PortalEstimateDetail';
import PortalInvoiceDetail from './pages/PortalInvoiceDetail';
import PortalJobDetail from './pages/PortalJobDetail';
import PortalMessage from './pages/PortalMessage';

/** Mounted at `/portal/:slug/*`. Login and the magic-link callback are public; the rest sits behind CustomerRoute. */
export default function PortalRoutes() {
  const { slug } = useParams<{ slug: string }>();
  return (
    <Routes>
      <Route index element={<PortalLogin />} />
      <Route path="auth" element={<PortalAuthCallback />} />
      <Route element={<CustomerRoute />}>
        <Route path="home" element={<PortalHome />} />
        <Route path="estimates/:id" element={<PortalEstimateDetail />} />
        <Route path="invoices/:id" element={<PortalInvoiceDetail />} />
        <Route path="jobs/:id" element={<PortalJobDetail />} />
        <Route path="message" element={<PortalMessage />} />
      </Route>
      <Route path="*" element={<Navigate to={`/portal/${slug ?? ''}`} replace />} />
    </Routes>
  );
}
